import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Icon from '~/components/icon/icon';
import RenderWithPermission from '~/containers/renderWithPermission/renderWithPermission';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import { permissions } from '../../utils/permissions';
import styles from './styles.css';

export default class SettingsPage extends Component {
  render() {
    return (
      <Page>
        <TitleBar title="Settings" />
        <URLParamBanner />
        <Card className="content pa3">
          <ul className="pa0 ma0 list grid grid-1-column grid-2-column-m grid-3-column-l gutter-column-1 gutter-row-1">
            <li>
              <Link to={`/settings/vesseltypes`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="shipment-in-transit" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">Vessel types</h5>
                    <p className="ma0">View and update the vessel types for product variations</p>
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link to={`/settings/locations`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="shelf" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">Storage locations</h5>
                    <p className="ma0">View and update the locations a vessel can go after a lot has finished</p>
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link to={`/settings/transfers`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="transfer" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">Transfer Schedules</h5>
                    <p className="ma0">View and update schedules of transfer steps for use when scheduling a new lot</p>
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link to={`/settings/hscodes`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="cube" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">HS Codes</h5>
                    <p className="ma0">View and update the list of transfer codes for assigning to a product</p>
                  </div>
                </div>
              </Link>
            </li>
            <RenderWithPermission permission={permissions.canUpdateBrewery}>
              <li>
                <Link to={`/settings/brewery`}>
                  <div className={`flex ${styles.setting} pa2 br1`}>
                    <Icon icon="brewery" className={`mr3 ${styles.icon}`} />
                    <div>
                      <h5 className="ma0 mb1">Brewery details</h5>
                      <p className="ma0">View and update brewery details like address or licence code</p>
                    </div>
                  </div>
                </Link>
              </li>
            </RenderWithPermission>
          </ul>
        </Card>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.jsx